document.addEventListener('DOMContentLoaded', () => {
  const svgs = [...document.querySelectorAll('.section-wave[data-direction]')];
  if (!svgs.length) return;

  const waves = svgs.map(svg => ({
    svg,
    group: svg.querySelector('.wave-group') || svg,
    dir: svg.dataset.direction === 'right' ? 1 : -1,
    speed: parseFloat(svg.dataset.speed || '0.5') || 0,
    center: 0,   // centered x
    min: 0,      // left clamp
    max: 0,      // right clamp
    anchorY: 0,  // scroll position when it became visible
    active: false
  }));

  // Measure & center (uses rendered px)
  function measure(w) {
    const svgW = w.svg.getBoundingClientRect().width || +w.svg.getAttribute('width') || 3499;
    const visW = (w.svg.parentElement?.getBoundingClientRect().width) || window.innerWidth;
    const extra = Math.max(0, svgW - visW);
    w.center = -extra / 2;  // start perfectly centered
    w.min = -extra;         // far left
    w.max = 0;              // far right
    // apply initial centered transform so "right" waves don’t show a gap
    w.group.style.transform = `translate3d(${w.center}px,0,0)`;
  }

  waves.forEach(w => {
    measure(w);
    w.group.style.willChange = 'transform';
  });

  // Activate only while visible; anchor motion to entry scrollY
  const io = new IntersectionObserver(entries => {
    for (const e of entries) {
      const w = waves.find(x => x.svg === e.target);
      if (!w) continue;
      if (e.isIntersecting) {
        measure(w);                 // keep centering correct on responsive layouts
        w.anchorY = window.scrollY; // start moving from centered position
        w.active = true;
      } else {
        w.active = false;
      }
    }
    requestAnimationFrame(update);
  }, { threshold: 0 });

  waves.forEach(w => io.observe(w.svg));

  let ticking = false;
  function update() {
    const y = window.scrollY;
    for (const w of waves) {
      if (!w.active) continue;
      const dx = (y - w.anchorY) * w.speed * w.dir;     // motion relative to entry
      let x = w.center + dx;                             // centered + delta
      x = Math.max(w.min, Math.min(w.max, x));           // soft clamp so edges never show
      w.group.style.transform = `translate3d(${x}px,0,0)`;
    }
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });

  window.addEventListener('resize', () => {
    waves.forEach(measure);
    requestAnimationFrame(update);
  }, { passive: true });

  requestAnimationFrame(update);
});